// extracted by mini-css-extract-plugin
export var saFaqSection = "saFaq-module--saFaqSection--247Jk";
export var saFaqTitleContainer = "saFaq-module--saFaqTitleContainer--2y-fX";
export var saFaqSubtitle = "saFaq-module--saFaqSubtitle--3QE6S";
export var saFaqListContainer = "saFaq-module--saFaqListContainer--2rvmL";
export var saFaqListItem = "saFaq-module--saFaqListItem--ilKwo";
export var saQ = "saFaq-module--saQ--zOcwa";
export var saA = "saFaq-module--saA--eYQTc";